<template>
  <div>
    <!-- FILTER START -->
    <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
          <h4 class="panel-title">Filter Option</h4>
      </template>
      <div class="row outerBox filterBox">
        <div class="col row">
          <div class="col-md-6 mobileFilterPaddingTop">
            <label for="partshopCode">Search</label>
            <input type="text" class="form-control" v-model="filter.search">
          </div>
          <div class="col-md-3 offset-md-3 mobileFilterPaddingTop" style="display: flex; flex-direction: column-reverse; padding-top:20px">
              <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
          </div>
        </div>
      </div>
    </panel>
    <!-- FILTER END -->

    <div class="innerBox mt-5">
      <h5 class="mb-2">Dealer Radius</h5>
      <vue-universal-table
        :api_url="'/api/setting/dealer-radius'"
        :filter="filter"
        :update="vue_universal_table.update"
        :fields="vue_universal_table.fields"
        :buttons="vue_universal_table.buttons"
        :sort_order="'DESC'"
        :sort_by="'created_at'"
        :special_buttons="['newDealerRadius']"
        @onNewDealerRadius="modal.new = true"
        @onEdit="editDealerRadius"
        @onDelete="deleteDealerRadius"
      ></vue-universal-table>
    </div>

    <!-- Modal Start -->
    <new-dealer-radius
      v-if="modal.new"
      @closeModal="modal.new = false"
      @refreshTable="vue_universal_table.update++"
      @triggerAlert="triggerAlert"
    ></new-dealer-radius>

    <edit-dealer-radius
      v-if="modal.edit"
      :data="modal.editData"
      @closeModal="modal.edit = false"
      @refreshTable="vue_universal_table.update++"
      @triggerAlert="triggerAlert"
    ></edit-dealer-radius>
    <!-- Modal End -->

    <!-- ALERT MESSAGE STARTS -->
      <transition name="fade">
        <div class="alert alertmessage" :class="{'alert-warning' : alert.isError, 'alert-success' : !alert.isError}" v-if="alert.showAlert">
          <strong v-if="alert.isError">Error!</strong>
          <strong v-else>Success!</strong>

          <br><br>
          <p v-for="message in alert.alertMessage">♢ {{ message }}</p>
        </div>
    </transition>
    <!-- ALERT MESSAGE ENDS -->

  </div>
</template>

<script>
  import newDealerRadius from './children/newDealerRadius'
  import editDealerRadius from './children/editDealerRadius'
  
  export default {
    data() {
      return {
        mobile: this.isMobile(),

        modal : {
          new : false,
          edit : false,
          editData : null,
        },

        alert : {
          showAlert : false,
          isError : false,
          alertMessage : [],
        },

        filter: {
          search: '',
        },
        vue_universal_table: {
          update: 0,
          fields: [
            {
              title: 'Dealer Code',
              variable: 'kd_dealer'
            },
            {
              title: 'Dealer Name',
              variable: 'name'
            },
            {
              title: 'Ring 1',
              variable: 'ring_1'
            },
            {
              title: 'Ring 2',
              variable: 'ring_2'
            },
            {
              title: 'Ring 3',
              variable: 'ring_3'
            }
          ],
          buttons : [
            {
              title: 'Edit',
              class: 'btn-sm btn-outline-primary'
            },
            {
              title: 'Delete',
              variable: 'kd_dealer',
              class: 'btn-sm btn-outline-danger'
            }
          ]
        },
      }
    },
    components : {
      newDealerRadius,
      editDealerRadius
    },
    mounted() {

    },
    methods: {
      triggerAlert(isError, alertMessage){//Boolean, Array
        let vm = this;

        vm.alert.isError = isError;
        vm.alert.alertMessage.length = 0;
        vm.alert.alertMessage = this.alert.alertMessage.concat(alertMessage);

        vm.alert.showAlert = true;
        setTimeout(()=>{
            vm.alert.showAlert = false;
        }, 5000);
      },
      editDealerRadius(dealerData){
        this.modal.editData = JSON.parse(dealerData);
        this.modal.edit = true;
      },
      deleteDealerRadius(dealer_code) {
        let vm = this;
        this.$swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085D6',
          cancelButtonColor: '#D33',
          confirmButtonText: 'Delete'
        }).then((result) => {
          if (result.value) {
            this.$http.delete(`/api/setting/dealer-radius/${JSON.parse(dealer_code)}`)
            .then((res) => {
              vm.vue_universal_table.update++
              vm.$swal.fire(
                'Deleted',
                'Dealer radius has been successfully removed',
                'success'
              )
            })
            .catch((err) => {
              console.log(err)
            })
          }
        })
      },
    }
  }
</script>

<style scoped>
  /* ALERT MESSAGE STARTS */
  .alertmessage {
      position: fixed;
      top: 10%;
      left: 47.5%;
      z-index:9999;
      width: 300px;
      text-align: center;
  }
  .alertmessage strong{
      font-size: 150%
  }
  .fade-enter-active, .fade-leave-active {
      transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
  }
  /* ALERT MESSAGE ENDS */
</style>